import API from "..";
import { API_MACHINE, API_MACHINE_UPDATE_DELETE } from "../../constants/api";

async function getMachines(ApiUrl) {
  try {
    const response = await API.get(ApiUrl);
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

async function addMachine(addData) {
  try {
    const response = await API.post(API_MACHINE, addData);
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

async function updateMachines(updateData, deleteIds) {
  try {
    const response = await API.post(
      API_MACHINE_UPDATE_DELETE,
      {
        machines: updateData,
        delete_machine_ids: deleteIds,
      },
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

export { getMachines, updateMachines, addMachine };
